<div class="filter-bar">
  <ng-content select="[filter-search]"></ng-content>
  <div class="segmented-popups">
    <ng-content select="[filter-group-popup]"></ng-content>
    <ng-content select="[filter-field-popup]"></ng-content>
  </div>
</div>
